const profileValidationES = {
    "email": {
        "required": "La dirección de correo electrónico es obligatoria"
    },
    "profile_image": {
        "dimensions": "El tamaño de la imagen de perfil debe ser exactamente 300 x 300 px, JPG/JPEG. Tamaño máximo del archivo 300 KB",
        "choose": "Por favor elige una imagen",
        "file": "El archivo seleccionado es mayor de 300 KB. Por favor sube una portada de 300x300 px, JPG/JPEG, tamaño máximo del archivo 300 KB."
    },
    "street_and_number": {
        "required": "La calle y el número de casa son obligatorios"
    },
    "postal_code": {
        "required": "El código postal es obligatorio"
    },
    "city": {
        "required": "La ciudad es obligatoria"
    },
    "country": {
        "required": "El país es obligatorio"
    },
    "vat_number": {
        "invalid": "El valor no es un número de IVA válido"
    },
    "iban": {
        "required": "El IBAN es obligatorio",
        "invalid": "El valor no es un número de IBAN válido"
    },
    "cardholder_name": {
        "required": "El nombre del titular de la tarjeta es obligatorio"
    },
    "card_number": {
        "required": "El número de tarjeta es obligatorio",
        "invalid": "El número de tarjeta no es válido"
    },
    "card_year": {
        "required": "El año de vencimiento es obligatorio",
        "invalid": "El año de vencimiento no es válido"
    },
    "card_month": {
        "required": "El mes de vencimiento es obligatorio"
    },
    "cvc_code": {
        "required": "El código de seguridad (CVC) es obligatorio",
        "invalid": "El código de seguridad (CVC) no es válido"
    },
    "paypal_email": {
        "required": "El correo electrónico de Paypal es obligatorio",
        "invalid": "El correo electrónico de Paypal no es válido"
    },
    "account_holder_name": {
        "required": "El nombre del titular de la cuenta bancaria es obligatorio"
    },
    "bank_name": {
        "required": "El nombre del banco es obligatorio"
    },
    "bank_address": {
        "required": "La dirección del banco es obligatoria"
    },
    "preferred_payment_method": {
        "required": "El método de pago preferido es obligatorio"
    }
};

export default profileValidationES;